import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { visuallyHidden } from '@mui/utils';
import type { SelectChangeEvent } from '@mui/material/Select';

interface FilterDropdownProps {
  default: string;
  filterOptions?: Array<string>;
  label: string;
  value: string;
  setFilter: (value: string) => void;
}

const FilterDropdown = ({
  default: defaultFilter,
  filterOptions,
  label,
  value,
  setFilter,
}: FilterDropdownProps) => {
  return (
    <FormControl
      fullWidth
      sx={{
        mx: { xs: 0, sm: 2 },
        my: 1,
        maxWidth: { xs: 'none', sm: '300px' },
         
        background: (theme) => (theme.palette as any).neutral[50],
      }}
    >
      <InputLabel id={`label-${defaultFilter}`} style={visuallyHidden}>
        {label}
      </InputLabel>
      <Select
        labelId={`label-${defaultFilter}`}
        value={value}
        displayEmpty
        defaultValue={defaultFilter}
        onChange={(event: SelectChangeEvent) => setFilter(event.target.value)}
        SelectDisplayProps={{ role: 'combobox', 'aria-activedescendant': value }}
      >
        <MenuItem value="">{defaultFilter}</MenuItem>
        {filterOptions?.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterDropdown;
